module.exports = __webpack_public_path__ + "static/media/gallery-12.4530f9ad.jpg";